import { useState } from 'react';
import { useAuth } from '../../auth/AuthProvider.jsx';
import { Card } from '../../components/ui/Card.jsx';
import { PeriodPicker } from '../../components/PeriodPicker.jsx';
import { AiInsights } from '../../components/analytics/AiInsights.jsx';
import { t } from '../../lib/i18n.js';

export function AdminDashboardPage() {
  const { user, hasPermission } = useAuth();
  const [period, setPeriod] = useState('30d');

  const canRead = hasPermission('analytics:read');
  const name = (user && (user.firstName || user.email)) || '';

  if (!canRead) {
    return (
      <div className="flex flex-col gap-6">
        <header>
          <h1 className="text-2xl font-semibold text-ink">{t('dashboard.title')}</h1>
          <p className="mt-1 text-sm text-ink-muted">{t('dashboard.welcome', { name })}</p>
        </header>
        <Card>
          <p className="text-sm text-ink-muted">
            Non hai il permesso <code className="rounded bg-border/40 px-1 py-0.5 text-xs">analytics:read</code> per visualizzare i dati di sintesi.
          </p>
        </Card>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-6">
      <header className="flex flex-wrap items-end justify-between gap-3">
        <div>
          <h1 className="text-2xl font-semibold text-ink">{t('dashboard.title')}</h1>
          <p className="mt-1 text-sm text-ink-muted">{t('dashboard.welcome', { name })}</p>
        </div>
        <PeriodPicker value={period} onChange={setPeriod} />
      </header>

      <AiInsights period={period} />
    </div>
  );
}
